import { OrderStatus, OrderStatuses } from 'src/constants/OrderStatus';

export function isPendingOrder(orderStatus: OrderStatus): boolean {
    return orderStatus === OrderStatuses.PENDING;
}
